import React from 'react';
import YouTube from 'react-youtube';


export default class YoutubeModal extends React.Component{

constructor(props){
  super(props);
  this.state={
    ready:false,

  }
}



  render(){
    return(
      <div style={{backgroundColor:"black",width:"100%",height:0, paddingBottom:"56%"}} ref={ (divElement) => this.divElement = divElement}>
        {this.state.ready===false  &&
          <div style={{textAlign:"center",width:"100%",paddingTop:"20%"}}>
            <div className="spinnerCircle" style={{height:60,width:60}} />
            <div style={{color:"white"}}>Loading Video...</div>
          </div>
        }
        <div style={{display: this.state.ready ? "" : "none" ,paddingBottom:"56%",position:"relative",overflow:"hidden"}}>
          <YouTube className="YoutubeContainer" opts={{playerVars: { autoplay:1}}} onReady={()=>{this.setState({ready:true})}} videoId={this.props.videoID}/>
        </div>
      </div>
    );
  }
}
